interface CookieOptions {
  days?: number;
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: 'Strict' | 'Lax' | 'None';
}

const DEFAULT_OPTIONS: CookieOptions = {
  days: 365, // 1 year expiration
  path: '/',
  secure: window.location.protocol === 'https:',
  sameSite: 'Lax',
};

export function setCookie(name: string, value: string, options: CookieOptions = {}): void {
  try {
    const opts = { ...DEFAULT_OPTIONS, ...options };
    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

    if (opts.days) {
      const date = new Date();
      date.setTime(date.getTime() + opts.days * 24 * 60 * 60 * 1000);
      cookieString += `; expires=${date.toUTCString()}`;
    }

    if (opts.path) {
      cookieString += `; path=${opts.path}`;
    }

    if (opts.domain) {
      cookieString += `; domain=${opts.domain}`;
    }

    if (opts.secure) {
      cookieString += '; secure';
    }

    if (opts.sameSite) {
      cookieString += `; SameSite=${opts.sameSite}`;
    }

    document.cookie = cookieString;
  } catch (e) {
    console.warn(`[cookieStorage] Failed to set cookie "${name}":`, e);
  }
}

export function getCookie(name: string): string | null {
  try {
    const nameEQ = encodeURIComponent(name) + '=';
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(nameEQ) === 0) {
        return decodeURIComponent(cookie.substring(nameEQ.length));
      }
    }

    return null;
  } catch (e) {
    console.warn(`[cookieStorage] Failed to get cookie "${name}":`, e);
    return null;
  }
}

export function removeCookie(name: string, options: CookieOptions = {}): void {
  try {
    const opts = { ...DEFAULT_OPTIONS, ...options };
    setCookie(name, '', { ...opts, days: -1 });
  } catch (e) {
    console.warn(`[cookieStorage] Failed to remove cookie "${name}":`, e);
  }
}

export const cookieStorage = {
  getCookie,
  setCookie,
  removeCookie,
};
